interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "text-center max-w-3xl mx-auto" : "max-w-3xl"}>
      <div
        className={`flex items-center gap-3 ${isCenter ? "justify-center" : ""}`}
      >
        <span className="h-px w-8 bg-primary-400" />
        <span className="font-label text-xs md:text-sm tracking-[0.32em] text-primary-700">
          {eyebrow}
        </span>
      </div>
      <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc && (
        <p className="mt-3 md:mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
          {desc}
        </p>
      )}
    </div>
  );
}